import { render, staticRenderFns } from "./joobyLogo.vue?vue&type=template&id=59e965d0"
import script from "./joobyLogo.vue?vue&type=script&lang=js"
export * from "./joobyLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports